/**
 * App brand mark (`/public/assets/brand/app-logo.png`).
 */
export const appBrandLogo = '/assets/brand/app-logo.png'

/**
 * 品牌化参考纹理（`/public/assets/brand-refs/`，与设计稿/外景图一致）。
 * 仅用于 UI 氛围，不参与业务逻辑。
 */
export const brandRefImages = Object.freeze({
  dubaiIslamicBankBranch: '/assets/brand-refs/dubai-islamic-bank-branch.png',
  mobileBankingHero: '/assets/brand-refs/mobile-banking-cards-hero.png',
  adnocRewards: '/assets/brand-refs/adnoc-rewards-hero.png',
  adcbBuilding: '/assets/brand-refs/adcb-building.png',
  mashreqBankBuilding: '/assets/brand-refs/mashreq-bank-building.png',
  emiratesNbdBuilding: '/assets/brand-refs/emirates-nbd-building.png',
})

/** 登录左侧栏等高对比叠层背景的底图推荐 */
export const loginAsideBrandBackdrop = brandRefImages.mobileBankingHero
